import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import { useGeneralStore } from '@/pinia'
import { computed, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MapOrthophotoButton',
  emits: ["MapOrthophotoButtonHovered"],
  setup(__props, { emit: __emit }) {

const emits = __emit
const piniaStore = useGeneralStore()

const buttonActive = ref(false)
const activeState = computed(() => {
  if (hoverButtons.value && hoverButtons.value.length)
    return buttonActive.value ? 'active' : 'inactive'
  return 'deactivated'
})

const hoverButtons = computed(() => {
  const layers: any[] = []
  piniaStore.filteredOrthophotos.forEach((orthophoto) => {
    layers.push({
      ...orthophoto,
      types: [{}],
      disabled: false
    })
  })
  return layers
})

function onHover() {
  if (activeState.value !== 'deactivated') {
    emits('MapOrthophotoButtonHovered')
  }
}
function toggleButton() {
  if (activeState.value === 'deactivated') return
  buttonActive.value = !buttonActive.value
}

function updateFilteredOrthophotos(id) {
  const orthophotoLayers = piniaStore.filteredOrthophotos
  const index = orthophotoLayers.findIndex((layer) => layer.id === id)
  if (index === -1) return
  orthophotoLayers[index].visible = !orthophotoLayers[index].visible
  piniaStore.setFilteredOrthophotos(orthophotoLayers)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonSquareHoverChecklist, {
    title: _ctx.$t('general__view__orthophoto'),
    imgSource: require('@/assets/icon-orthophoto.svg'),
    size: "large",
    hoverButtons: hoverButtons.value,
    activeState: activeState.value,
    onClicked: toggleButton,
    onHovered: onHover,
    onOnChecklistToggle: updateFilteredOrthophotos
  }, null, 8, ["title", "imgSource", "hoverButtons", "activeState"]))
}
}

})